<template>
  <div class="container">
    <h1 class="h5 my-2">{{ $t("order-item-messages") }}</h1>
    <div v-if="orderId && orderItemId">
      <div class="my-2">
        {{
          $t("PageConversation-order-serial-number", {
            orderId: orderId,
            serialNumber: sn || "-",
            personName: person,
          })
        }}
      </div>
      <hr />
      <order-messages-body :orderid="orderId" :order-itemid="orderItemId" />
    </div>
    <div
      v-else
      class="alert alert-primary d-flex flex-column align-items-center my-2"
    >
      {{ $t("url-not-valid-try-again") }}
      <button class="btn btn-primary mt-2" @click="goBack">
        {{ $t("go-back") }}
      </button>
    </div>
  </div>
</template>

<script>
import OrderMessagesBody from "@/components/order/OrderMessagesBody.vue";

export default {
  name: "PageConversation",
  components: {
    OrderMessagesBody,
  },
  data() {
    return {
      orderId: null,
      orderItemId: null,
      sn: null,
      person: null,
    };
  },
  created() {
    this.setOrderDataFromUrlParams();
  },
  methods: {
    setOrderDataFromUrlParams() {
      const urlParams = new URLSearchParams(window.location.search);
      this.orderId = urlParams.get("orderId");
      this.orderItemId = Number(urlParams.get("orderItemId"));
      if (isNaN(this.orderItemId)) {
        console.error(
          "orderItemId is not a number:",
          urlParams.get("orderItemId"),
        );
      }
      this.sn = urlParams.get("sn");
      this.person = urlParams.get("person");
    },
    goBack() {
      history.back();
    },
  },
};
</script>

<style></style>
